import { PrizeInfo, QuizPrize } from '@longnecktech/splash-commons-fe';
import { GroupedPrizePackage } from '@shared/types/prize-package';

export function groupConsecutivePrizes(
  packages: PrizeInfo<QuizPrize>[] | undefined,
): GroupedPrizePackage[] {
  if (!packages || packages.length === 0) return [];

  const grouped: GroupedPrizePackage[] = [];
  let currentGroup = [packages[0]];

  for (let i = 1; i < packages.length; i++) {
    if (packages[i].prize.uuid === currentGroup[0].prize.uuid) {
      // if the current package has the same uuid as the group, add it to the group
      currentGroup.push(packages[i]);
    } else {
      // if the uuid is different, add the previous group to the result
      // and start a new group
      grouped.push(currentGroup.length > 1 ? currentGroup : currentGroup[0]);
      currentGroup = [packages[i]];
    }
  }
  // add the last group
  grouped.push(currentGroup.length > 1 ? currentGroup : currentGroup[0]);
  return grouped;
}
